import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';
import { Circles } from 'react-loader-spinner';
import { sanityClient } from '../client';

const Stats = () => {
  /*   const stats = [
    {
      number: 100,
      title: 'Mentored',
    },
    {
      number: 100,
      title: 'Projects',
    },
    {
      number: 100,
      title: 'Mentored',
    },
  ];
 */ const [stats, setStats] = useState(null);
  useEffect(() => {
    sanityClient
      .fetch(`*[_type=="stats"]`)
      .then((data) => setStats(data))
      .catch(console.error);
  }, []);
  if (!stats)
    return (
      <div className="flex  items-center justify-center ">
        <Circles height={30} width={30} color="#5bccf6" />
      </div>
    );

  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: [1],
      }}
      transition={{
        delay: 2.5,
        duration: 1,
      }}
      className="absolute top-24 flex items-center gap-5 md:gap-20 justify-center"
    >
      {stats.map((stat) => (
        <div>
          <h1 className="text-2xl md:text-5xl font-bold">
            <CountUp end={stat.value} duration={10} delay={1} />
            <span className="text-[#5bccf6] font-thin ml-2">+</span>
          </h1>
          <p className="text-sm text-gray-600 font-thin text-2xl tracking-wider md:tracking-widest uppercase">
            {stat.title}
          </p>
        </div>
      ))}
    </motion.div>
  );
};

export default Stats;
